import React, { Component } from 'react'
import * as styles from './mutuallink.module.css'

export default class Mutuallink extends Component {

  render() {
    return (
      <div className={styles.mutuallink}>
        <p className='heading' style={{ marginBottom: `20px` }}>相互リンクさせて頂いているサイト</p>
        <div className={styles.mutuallink_contents}>
          <div className={styles.mutuallink_site}>
            <p><a href="https://oppai-doga.info/" target="_blank" rel="noreferrer">おっぱい動画＠巨乳・美乳まとめ</a></p>
            <p><a href="https://avreview24.com/" target="_blank" rel="noreferrer">抜けるAVレビュー</a></p>
            <p><a href="https://irm.avlabo.com/" target="_blank" rel="noreferrer">イマラチオ研究所</a></p>
            <p><a href="https://www.hamejio.com/" target="_blank" rel="noreferrer">痴漢×制服×ハメ潮＝破壊力</a></p>
            <p><a href="https://www.momokoki.com/" target="_blank" rel="noreferrer">ももコキ大全</a></p>
            <p><a href="https://hairy-pedia.com/" target="_blank" rel="noreferrer">剛毛大百科</a></p>
            <p><a href="https://ero-cos.net/" target="_blank" rel="noreferrer">エロコス</a></p>
            <p><a href="https://ntr-magazine.com/" target="_blank" rel="noreferrer">ネトラレマガジン</a></p>
            {/*<p><a href="https://onatetsu.com/" target="_blank" rel="noreferrer">ヲナ研</a></p>*/}
            <p><a href="https://ipai.tokyo/" target="_blank" rel="noreferrer">アイドルの擬似パイズリ図鑑</a></p>
            {/*<p><a href="https://paipai-only.com/" target="_blank" rel="noreferrer">パイズリマニアの館</a></p>*/}
            <p><a href="https://av-seikatsu.com/" target="_blank" rel="noreferrer nofollow">AV性活</a></p>
          </div>
        </div>
      </div>
    )
  }
}